export default __webpack_public_path__ + "static/media/category_c.e5bdd6ee.svg";